import { Label, Error, ClassHelper } from 'components/lib';
import Style from './searchableDropdown.tailwind.js';
import { useState } from 'react';

export function SearchableDropdown(props) {

  const [optionVisibility, setOptionVisibility] = useState(false);
  const [value, setValue] = useState('');
  const [label, setLabel] = useState(props.value || '');
  const [filtered, setFiltered] = useState(props.options || []);
  let options = props.options;
  const error = props.errorMessage || 'Please select an option';

  function change(e) {
    let filtered
    if (e.target?.value !== '') {
      filtered = options?.filter(x => x.label.toLowerCase().includes(e.target?.value.toLowerCase()));
      setLabel(e.target?.value);
    } else {
      filtered = options;
      setLabel('');
    }
    setFiltered(filtered);
    setOptionVisibility(true);
    props.callback && props.callback(e.target?.value);

  }

  function click(e) {
    let valid = undefined;
    let option = options?.find(x => x.value === e.target.value);
    setLabel(option?.label);
    setValue(option?.value);
    valid = props.required && value === 'unselected' ? false : true;
    props.onChange && props.onChange(props.name, option?.value, valid);
    props.callback && props.callback(option?.label);
  }

  function inputClick(e) {
    let filtered
    if (e.target?.value !== '') {
      filtered = options?.filter(x => x.label.toLowerCase().includes(e.target?.value.toLowerCase()));
      setLabel(e.target?.value);
    } else {
      filtered = options;
      setLabel('');
    }
    setFiltered(filtered);
    setOptionVisibility(true);
  }

  const wrapperStyle = ClassHelper(Style, {

    className: props.className,
    success: props.valid === true,
    errorWrapper: props.valid === false,
    warningWrapper: props.warning,

  });

  const selectStyle = ClassHelper(Style, {

    select: true,
    error: props.valid === false,
    warning: props.warning,
    className: props.inputStyle,

  });

  return (
    <div className={`${Style.input} ${props.parentStyle || ''}`}>
      {props.label &&
        <Label
          text={props.label}
          required={props.required}
          for={props.name}
        />}

      <div className={wrapperStyle}>
        <input
          type={props.type}
          id={props.name}
          name={props.name}
          className={selectStyle}
          value={label}
          placeholder={props.placeholder}
          disabled={props.disabled}
          onChange={change}
          onBlur={() => setOptionVisibility(false)}
          onClick={inputClick}
          defaultValue={props.default}
        />
        {optionVisibility &&
          <div className={Style.dropdown} >
            {filtered?.map(option => {
              return (
                <option
                  key={option.value}
                  value={option.value}
                  className={Style.dropdownItem}
                  onMouseDown={click}
                  onMouseUp={() => setOptionVisibility(false)}
                  {...option.value === 'unselected' && { disabled: true }}
                >
                  {option.label}
                </option>
              );
            })}
          </div>
        }

        {props.valid === false && <Error message={error} className={Style.message} />}

      </div>
    </div>
  );
}